export default {
  'subscription-funnel:page-title': 'Pets Deli Subscription Configurator',
  'subscription-funnel:dog': 'My Dog',
  'subscription-funnel:cat': 'My Cat',
  'subscription-funnel:WET_FOOD': 'Wet Food',
  'subscription-funnel:DRY_FOOD': 'Dry Food',
  'subscription-funnel:BARF': 'BARF',
  'subscription-funnel:SNACKS': 'Snacks',
  'subscription-funnel:SUPPLEMENTS': 'Supplements',
  'subscription-funnel:HEALTH': 'Health',
  'subscription-funnel:CAT_LITTER': 'Cat Litter',
  'subscription-funnel:ACCESSORY': 'Accessory',
  'subscription-funnel:button:continue': 'Continue',

  'subscription-funnel:step:preference': 'Preference',
  'subscription-funnel:step:products': 'Products',
  'subscription-funnel:step:overview': 'Overview',
  'subscription-funnel:step:confirm': 'Confirmation',

  'subscription-funnel:step:payment': 'Payment',
  'subscription-funnel:step:confirmation': 'Done',

  'subscription-funnel:start:header': 'Your personal Pets Deli subscription in 4 steps',
  'subscription-funnel:start:list:item-1':
    'Save with every delivery! With a subscription, we offer you a permanent 10% discount on your favorite products.',
  'subscription-funnel:start:list:item-2':
    'With no minimum term, you can cancel or pause your subscription at any time. Promised!',
  'subscription-funnel:start:list:item-3':
    'Full flexibility! Choose an individual delivery interval and decide when you want to receive your next package.',
  'subscription-funnel:start:button-configure': 'Configure now',

  'subscription-funnel:preference:header': 'Choose your preferences',
  'subscription-funnel:preference:sub-header':
    'Whether for dogs or cats, just wet food or a mix of BARF and dry food, the choice is yours!',
  'subscription-funnel:preference:question-1':
    'Who do you want to make happy with your subscription?',
  'subscription-funnel:preference:question-2': 'Which food should be included in the subscription?',
  'subscription-funnel:preference:selection-info': 'Multiple selections possible',
  'subscription-funnel:preference:button:continue': 'Choose your preferences',

  'subscription-funnel:products:header': 'Choose your products',
  'subscription-funnel:products:sub-header':
    'Simply click on the product tiles. You can get more information via the info icon.',
  'subscription-funnel:products:info-loading':
    'Loading suitable products for your four-legged friend...',
  'subscription-funnel:products:modal:info-loading': 'Loading product info...',
  'subscription-funnel:products:results': 'Results',
  'subscription-funnel:products:back-button:label': 'Back to preferences',

  'subscription-funnel:overview:header': 'Your Overview',
  'subscription-funnel:overview:header-existing-order': 'Your Confirmation',

  'subscription-funnel:overview:sub-header':
    "You're almost there. Check again that you haven't forgotten any products.",

  'subscription-funnel:overview:sub-header-existing-order':
    "You're almost there! Please confirm the selection of products to be newly added to your subscription.",

  'subscription-funnel:overview:new-items-existing-order': 'New products in your subscription:',

  'subscription-funnel:overview:delivery-address':
    'Your delivery address and estimated delivery date',

  'subscription-funnel:overview:delivery-date':
    'Your order will be processed shortly and is expected to be ready by {dateStr}',

  'subscription-funnel:overview:button:to-checkout': 'To Checkout',
  'subscription-funnel:overview:button:to-subscription-update': 'Confirm',

  'subscription-funnel:confirmation:sub-header':
    'You can adjust your subscription at any time in your account',

  'subscription-funnel:confirmation:cta': 'Adjust Now',

  'subscription-funnel:cart-show': 'Show Subscription',
  'subscription-funnel:cart-hide': 'Hide Subscription',

  'subscription-funnel:existing-subscription:cart-show': 'Show Order Summary',
  'subscription-funnel:existing-subscription:cart-hide': 'Hide Order Summary',
};
